import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useGetMe } from '@/hooks/shared/useGetMe';
import { ACCOUNT_TYPES } from '@/helpers/constants';
import s from './index.module.scss';

export const AccountTypeTabs = ({ selected, className, onChange }) => {
  const { isCombinedMode } = useGetMe();
  const { t } = useTranslation('components');

  if (!isCombinedMode) return null;

  return (
    <div className={classnames(s.tabs, className)}>
      <div
        className={classnames(s.tab, selected === ACCOUNT_TYPES.business && s.tab_active, 'hov')}
        onClick={() => onChange(ACCOUNT_TYPES.business)}
      >
        {t('acc_type_tabs.business')}
      </div>
      <div
        className={classnames(s.tab, selected === ACCOUNT_TYPES.personal && s.tab_active, 'hov')}
        onClick={() => onChange(ACCOUNT_TYPES.personal)}
      >
        {t('acc_type_tabs.personal')}
      </div>
    </div>
  );
};
